import { Pedestrismo, PedestrismoBackup } from '../constants/enums';
import { formatResultDuration } from './result-duration';

export default function getRecentRegistrations(participants, info, startedAt, limit = 15) {
  if (!startedAt || !Array.isArray(participants)) return [];
  const pedestrian = info.competition === Pedestrismo || info.competition === PedestrismoBackup;
  const distances = [1, 2, 3].map(index => ({
    type: String(info['distance' + index + 'Type'] || '').trim(),
    offset: Number(info['distance' + index + 'StartOffset']) || 0
  }));
  const categories = Array.isArray(info.categoryStartOffsets) ? info.categoryStartOffsets : [];
  return participants.map((participant, index) => {
    const registered = Number(participant.registeredTime1) || 0;
    if (!registered || Number(participant.dns) || Number(participant.disqualified) || Number(participant.dnf)) return null;
    const distance = distances.find(item => item.type === String(participant.distance || '').trim());
    const category = categories.find(item => String(item.catCod || '').trim() === String(participant.catCod || '').trim());
    const offset = pedestrian ? (distance ? distance.offset : 0) : (category ? Number(category.offset) || 0 : 0);
    // Pedestrian timestamps already have the distance offset subtracted.
    // Restore it only for arrival ordering, never for the displayed net time.
    const arrival = Math.max(registered + (pedestrian ? offset * 60000 : 0),
      Number(participant.registeredTime2) || 0, Number(participant.registeredTime3) || 0);
    return {
      key: index,
      number: participant.number,
      distance: participant.distance,
      arrival,
      time: formatResultDuration(registered - Number(startedAt) - (pedestrian ? 0 : offset * 60000))
    };
  }).filter(Boolean).sort((a, b) => b.arrival - a.arrival || b.key - a.key).slice(0, limit);
}



// WEBPACK FOOTER //
// ./src/utils/recent-registrations.js